import { Ed25519Pk } from "./Ed25519.js";
import { Willow25 } from "./Willow25.js";
export class SubspaceId extends Ed25519Pk {
    static default() {
        return this.copy(Willow25.DEFAULT_SUBSPACE_ID);
    }
}
//# sourceMappingURL=SubspaceId.js.map